import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumbs = ({ items = [] }) => (
  <nav aria-label="Breadcrumb" className="bg-[#F7F7F5] border-b border-gray-200">
    <div className="max-w-7xl mx-auto px-6 py-3 flex items-center gap-2 text-sm overflow-x-auto">
      <Link to="/" className="inline-flex items-center gap-1 text-gray-600 hover:text-[#D9A04A] transition-colors">
        <Home size={14} /> Home
      </Link>
      {items.map((it, idx) => (
        <React.Fragment key={idx}>
          <ChevronRight size={14} className="text-gray-400 flex-shrink-0" />
          {idx === items.length - 1 ? (
            <span className="text-[#2C5F66] font-semibold whitespace-nowrap">{it.name}</span>
          ) : (
            <Link to={it.path} className="text-gray-600 hover:text-[#D9A04A] transition-colors whitespace-nowrap">{it.name}</Link>
          )}
        </React.Fragment>
      ))}
    </div>
  </nav>
);

export default Breadcrumbs;
